import uniqBy from 'lodash/uniqBy';
import * as timelineConst from './timelineConstants';
import {TimelineType} from '../../models/enums/timeline';
import path from 'path';

export function  getTypeColor(type) {
  if (timelineConst.greenGroup.includes(type)) {
    return timelineConst.greenGroupColor;
  }

  if (timelineConst.redGroup.includes(type)) {
    return timelineConst.redGroupColor;
  }

  return timelineConst.greyGroup.includes(type) ? timelineConst.greyGroupColor : timelineConst.blueGroupColor;
}

export function getDetailsLink(event, currentPools) {
  if (timelineConst.analysisNoteTypes.includes(event.type) && event.data.data.systemID !== undefined) {
    return path.join('customer',
      event.customerID.toString(),
      event.data.data.systemID.toString(),
      'analysis',
      'report',
      'history',
      event.data.data.analysisID.toString(),
      'print');
  }

  if (timelineConst.systemDetailsLinkTypes.includes(event.type) && !currentPools.includes(event.poolID)) {
    return timelineConst.customerNoteTypes.includes(event.type) ?
      path.join('customer', event.customerID.toString(), 'notes') :
      null;
  }

  if (!timelineConst.systemDetailsLinkTypes.includes(event.type)) {
    return timelineConst.POSTypes.includes(event.type) ? path.join('customer', 'purchaseDetails', event.customerID.toString()) : null;
  }

  if (timelineConst.systemNoteTypes.includes(event.type)) {
    return event.data.data.SystemID ? path.join('customer', event.customerID.toString(), event.data.data.SystemID.toString(), 'notes') : null;
  }

  if (timelineConst.systemTypes.includes(event.type)) {
    return path.join('customer', event.customerID.toString(), event.poolID.toString(), 'details');
  }

  if (event.type === TimelineType.SystemAnalysisUpdated) {
    return path.join('customer', event.customerID.toString(), event.poolID.toString(), 'report-history');
  }

  if (timelineConst.analysisTypes.includes(event.type)) {
    return event.data.data.ID ?
      path.join('customer', event.customerID.toString(), event.poolID.toString(), 'analysis', 'report', 'history', event.data.data.ID.toString(), 'print') :
      null;
  }

  if (event.type === TimelineType.SystemNoteScript) {
    return event.poolID ? path.join('customer', event.customerID.toString(), event.poolID.toString(), 'notes') : null;
  }

  if (timelineConst.sourceWaterType.includes(event.type)) {
    return event.poolID ? path.join('customer', event.customerID.toString(), event.poolID.toString(), 'source') : null;
  }

  if (!timelineConst.analysisScriptTypes.includes(event.type)) {
    return null;
  }

  return event.poolID ?
    path.join('customer', event.customerID.toString(), event.poolID.toString(), 'analysis', 'report', 'history', event.data.id.toString(), 'print') :
    null;
}

// Filter out those which do not satisfy all 3 filters
export function getFiltered(events, filters) {
  return filters === null || filters.length === 0 ?
    events :
    events.filter(e => !filters.some(f => !!f.value && f.filter === 'event' && !JSON.parse(`[${f.value}]`).includes(e.type)));
}
